// extracted by mini-css-extract-plugin
module.exports = {"root":"bv_b9","body":"bv_x"};